import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import UsersIndex from "@/views/users/index.vue";
import PartsIndex from "@/views/parts/index.vue";
import InventoryIndex from "@/views/inventory/index.vue";
import SupplierIndex from "@/views/suppliers/index.vue";
import StockRequestIndex from "@/views/stockrequest/index.vue";
import PurchaseOrder from "@/views/purchaseorder/index.vue";
import Currency from "@/views/currency/index.vue";
import StockoutIndex from "@/views/stockout/index.vue";
import ReportIndex from "@/views/reports/index.vue";

import store from "@/store/";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      meta: { requiresAuth: true },
      component: () => import("@/views/layouts/default.vue"),
      children: [
        {
          path: "",
          component: Home,
          meta: { requiresAuth: true },
          children: [
            {
              path: "",
              // name: "chart",
              name: "home",
              component: () => import("@/views/supervisor/chart.vue")
            },
            {
              path: "pending",
              name: "dashboard_pending",
              component: () => import("@/views/supervisor/pending.vue")
            },
            {
              path: "completed",
              name: "dashboard_completed",
              component: () => import("@/views/supervisor/completed.vue")
            }
          ]
        },
        {
          path: "/users",
          component: UsersIndex,
          meta: {
            requiresAuth: true,
            menu: { name: "Users", icon: "el-icon-user" },
            userType: 1
          },
          children: [
            {
              path: "",
              name: "users",
              component: () => import("@/views/users/list.vue")
            },
            {
              path: "info/:id?",
              name: "user_info",
              component: () => import("@/views/users/form.vue")
            }
          ]
        },
        {
          path: "/currency",
          component: Currency,
          meta: {
            requiresAuth: true,
            menu: { name: "Currency", icon: "el-icon-money" },
            userType: 1
          },
          children: [
            {
              path: "",
              name: "currency",
              component: () => import("@/views/currency/list.vue")
            },
            {
              path: "info/:id?",
              name: "currency_info",
              component: () => import("@/views/currency/info.vue")
            }
          ]
        },
        {
          path: "/suppliers",
          component: SupplierIndex,
          meta: {
            requiresAuth: true,
            menu: { name: "Suppliers", icon: "el-icon-s-custom" },
            userType: [1, 2]
          },
          children: [
            {
              path: "",
              name: "suppliers",
              component: () => import("@/views/suppliers/list.vue")
            },
            {
              path: "info/:id?",
              props: true,
              name: "supplier_info",
              component: () => import("@/views/suppliers/form.vue")
            }
          ]
        },
        {
          path: "/parts",
          component: PartsIndex,
          meta: {
            requiresAuth: true,
            menu: { name: "Parts", icon: "el-icon-cpu" },
            userType: [1, 2, 3, 4]
          },
          children: [
            {
              path: "",
              name: "parts",
              component: () => import("@/views/parts/list.vue")
            },
            {
              path: "info/:id?",
              name: "parts_info",
              component: () => import("@/views/parts/form.vue")
            }
          ]
        },
        {
          path: "/stockrequest",
          component: StockRequestIndex,
          meta: {
            requiresAuth: true,
            menu: { name: "Stock Request", icon: "el-icon-notebook-2" },
            userType: [1, 2]
          },
          children: [
            {
              path: "",
              name: "stockrequest",
              component: () => import("@/views/stockrequest/list.vue")
            },
            {
              path: "info/:id?",
              name: "request_info",
              component: () => import("@/views/stockrequest/info.vue")
            }
          ]
        },
        {
          path: "/purchaseorder",
          component: PurchaseOrder,
          meta: {
            requiresAuth: true,
            menu: { name: "Purchase Order", icon: "el-icon-s-management" },
            userType: [1]
          },
          children: [
            {
              path: "",
              name: "purchaseorder",
              component: () => import("@/views/purchaseorder/list.vue")
            },
            {
              path: "info/:id?",
              name: "purchaseorder_info",
              component: () => import("@/views/purchaseorder/info.vue")
            }
          ]
        },
        {
          path: "/batchcontrol",
          component: InventoryIndex,
          meta: {
            requiresAuth: true,
            menu: { name: "Batch Control", icon: "el-icon-box" },
            userType: [1, 2]
          },
          children: [
            {
              path: "",
              name: "batchcontrol",
              component: () => import("@/views/inventory/list.vue")
            },
            {
              path: "batch/:id?",
              name: "batch_info",
              component: () => import("@/views/inventory/request.vue")
            }
          ]
        },
        {
          path: "/stockout",
          component: StockoutIndex,
          meta: {
            requiresAuth: true,
            menu: { name: "Stock Out", icon: "el-icon-s-unfold" },
            userType: [1, 2, 4]
          },
          children: [
            {
              path: "",
              name: "stockout",
              component: () => import("@/views/stockout/list.vue")
            },
            {
              path: "info/:id?",
              name: "stockout_info",
              component: () => import("@/views/stockout/info.vue")
            }
          ]
        },
        {
          path: "/repair",
          component: () => import("@/views/repair/index.vue"),
          meta: {
            requiresAuth: true,
            menu: { name: "Repair", icon: "el-icon-brush" },
            userType: [1, 2, 3, 4]
          },
          children: [
            {
              path: "",
              name: "repair",
              component: () => import("@/views/repair/list.vue")
            },
            {
              path: "repair-parts",
              name: "repairParts",
              meta: { menu: { name: "ULD Part No." }, userType: [1, 4] },
              component: () => import("@/views/repair/spareParts.vue")
            },
            {
              path: "repair-status",
              name: "repairStatus",
              meta: { menu: { name: "Status" }, userType: [1] },
              component: () => import("@/views/repair/repairStatus.vue")
            },
            {
              path: "repair-uld-descriptions",
              name: "repairUldDescriptions",
              meta: { menu: { name: "ULD Descriptions" }, userType: [1] },
              component: () => import("@/views/repair/repairDescription.vue")
            },
            {
              path: "repair-uld-categories",
              name: "repairUldCategories",
              meta: { menu: { name: "ULD Categories" }, userType: [1] },
              component: () => import("@/views/repair/repairCategory.vue")
            },
            {
              path: "repair-location",
              name: "repairLocation",
              meta: { menu: { name: "Location" }, userType: [1] },
              component: () => import("@/views/repair/repairLocation.vue")
            },
            {
              path: "repair-cmm",
              name: "repairCMM",
              meta: { menu: { name: "CMM Details" }, userType: [1] },
              component: () => import("@/views/repair/repairCMM.vue")
            },
            {
              path: "repair-manufacturer",
              name: "repairManufactuter",
              meta: { menu: { name: "Manufacturer" }, userType: [1] },
              component: () => import("@/views/repair/repairManufacturer.vue")
            },
            {
              path: "repair-masterlist",
              name: "repairMasterlist",
              meta: {
                menu: { name: "Masterlist Details" },
                userType: [1, 2, 4]
              },
              component: () => import("@/views/repair/repairMasterlist.vue")
            },
            {
              path: "repair-masterlist-uld/:id",
              name: "repairMasterlistUld",
              component: () => import("@/views/repair/Masterlist/uldList.vue")
            },
            {
              path: "repair-uld",
              meta: {
                proxy: "repairULD",
                menu: { name: "ULD In" },
                userType: [1, 2, 3, 4]
              },
              component: () => import("@/views/repair/ULD/index.vue"),
              children: [
                {
                  path: "",
                  name: "repairULD",
                  component: () => import("@/views/repair/ULD/list.vue")
                },
                {
                  path: "info/:id?",
                  name: "repairULD_info",
                  component: () => import("@/views/repair/ULD/info.vue")
                }
              ]
            },
            {
              path: "repair-damage-part",
              name: "repairDamagePart",
              meta: { menu: { name: "Damage Part" }, userType: [1] },
              component: () => import("@/views/repair/repairDamagePart.vue")
            },
            {
              path: "repair-customer",
              name: "repairCustomer",
              meta: { menu: { name: "Customers" }, userType: [1] },
              component: () => import("@/views/repair/customers.vue")
            },
            {
              path: "repair-damage-descriptions",
              name: "repairDamageDesc",
              meta: { menu: { name: "Damage Description" }, userType: [1] },
              component: () => import("@/views/repair/repairDamageDesc.vue")
            },
            {
              path: "repair-uld-invoice",
              name: "repairULD_Invoice",
              meta: { menu: { name: "ULD Invoice" }, userType: [1, 4] },
              component: () => import("@/views/repair/ULD/invoice/list.vue")
            },
            // {
            //   path: "repair-uld-invoice/form/:id?",
            //   name: "repairULD_InvoiceForm",
            //   component: () => import("@/views/repair/ULD/invoice/invoice.vue"),
            // },
            {
              path: "repair-uld-out",
              meta: { menu: { name: "ULD Out" }, userType: [1, 4] },
              name: "repairULD_Out",
              component: () => import("@/views/repair/ULDOut/out.vue")
            }

            // {
            //   path: "repair-requested-parts",
            //   name: "repairRequestedParts",
            //   meta: { menu: { name: "Requested Parts" }, userType: [1, 2, 4] },
            //   component: () => import("@/views/repair/repairRequestedParts.vue")
            // }
          ]
        },
        {
          path: "/reports",
          component: ReportIndex,
          meta: {
            requiresAuth: true,
            menu: { name: "Reports", icon: "el-icon-s-order" },
            userType: [1, 2, 4]
          },
          children: [
            {
              path: "",
              name: "reports",
              component: () => import("@/views/reports/list.vue")
            },
            {
              path: "inventory",
              name: "inventoryReport",
              meta: { menu: { name: "Inventory" } },
              component: () => import("@/views/reports/inventory.vue")
            },
            {
              path: "stockout",
              name: "stockoutReport",
              meta: { menu: { name: "Stockout Report" } },
              component: () => import("@/views/reports/stockout.vue")
            },
            {
              path: "stockin",
              name: "stockinReport",
              meta: { menu: { name: "Stockin Report" } },
              component: () => import("@/views/reports/stockin.vue")
            },
            {
              path: "nonmoving",
              name: "nonmoving",
              meta: { menu: { name: "Non-Moving" } },
              component: () => import("@/views/reports/nonmoving.vue")
            },
            {
              path: "delivery-note",
              name: "deliveryReport",
              meta: { menu: { name: "Delivery Note" }, userType: [1, 3, 4] },
              component: () => import("@/views/reports/deliveryNote.vue")
            },
            {
              path: "production",
              name: "ProductionReport",
              meta: { menu: { name: "Production Report" } },
              component: () => import("@/views/reports/ProductionReport.vue")
            },
            {
              path: "damage_report",
              name: "DamageReport",
              meta: { menu: { name: "Damage Report" } },
              component: () => import("@/views/reports/DamageReport.vue")
            }
            // {
            //   path: "uld-invoice-report",
            //   name: "uldInvoiceReport",
            //   meta: { menu: { name: "ULD Invoice Report" } },
            //   component: () => import("@/views/reports/uldInvoice.vue")
            // }

            // {
            //   path: "other",
            //   name: "otherReport",
            //   meta: { menu: { name: "Other" } },
            //   component: () => import("@/views/reports/inventory.vue")
            // }
          ]
        },
        {
          path: "/profile",
          name: "user_profile",
          meta: {
            requiresAuth: true
          },
          component: () => import("@/views/users/profile.vue")
        }
      ]
    },
    {
      path: "/login",
      component: () => import("@/views/layouts/login.vue"),
      children: [
        {
          path: "",
          name: "login",
          component: () => import("@/views/Login.vue")
        }
      ]
    },
    {
      path: "/print",
      meta: {
        requiresAuth: true
      },
      component: () => import("@/views/layouts/print.vue"),
      children: [
        {
          path: "purchaseorder/:id",
          name: "purchaseorder_print",
          component: () => import("@/views/purchaseorder/print.vue")
        },
        {
          path: "inspectionsheet/:id",
          name: "print_inspectionSheet",
          component: () => import("@/views/inventory/inspectionSheetPrint.vue")
        },
        {
          path: "barcode/:id",
          name: "print_barcode",
          component: () => import("@/views/inventory/barcodePrint.vue")
        },
        {
          path: "partbarcode/:id",
          name: "print_partbarcode",
          component: () => import("@/views/parts/barcode.vue")
        },
        {
          path: "uld/:id",
          name: "print_uld",
          component: () => import("@/views/repair/ULD/print.vue")
        },
        {
          path: "uld-form-1A/:id",
          name: "print_uld_form1A",
          component: () => import("@/views/repair/ULD/easa.vue")
        },
        {
          path: "uld-form-easa/:id",
          name: "print_uld_form1_easa",
          component: () => import("@/views/repair/ULD/easa.vue")
        },
        {
          path: "delivery-note-pdf",
          name: "deliveryReportPDF",
          component: () => import("@/views/reports/deliveryNotePDF.vue")
        },
        {
          path: "repair-uld-out/:id",
          name: "repairULD_Out_Info",
          component: () => import("@/views/repair/ULDOut/outBatch.vue")
        },
        {
          path: "repair-estimate-report/:id",
          name: "repairEstimateReport",
          component: () => import("@/views/repair/ULD/estimateReport.vue")
        }
      ]
    },
    {
      path: "/pdf-viewer",
      meta: {
        requiresAuth: true
      },
      component: () => import("@/views/layouts/print.vue"),
      children: [
        {
          path: "doc",
          name: "pdf_viewer",
          component: () => import("@/views/reports/pdf.vue")
        }
      ]
    },
    {
      path: "*",
      component: () => import("@/views/layouts/default.vue"),
      children: [
        {
          path: "",
          beforeEnter: (to, from, next) => {
            next({ name: "notfound", params: { oldPath: to.fullPath } });
          }
        },
        {
          path: "/e404",
          name: "notfound",
          component: () => import("@/views/errors/e404.vue")
        },
        {
          path: "/e401",
          name: "unauthorized",
          component: () => import("@/views/errors/e401.vue")
        }
      ]
    }
  ]
});

// perform route authorization based on user.user_type
router.beforeEach((to, from, next) => {
  let check = store.getters["auth/check"];
  let user = store.getters["auth/user"];
  if (to.name == "login" && check) {
    next({
      name: "home"
    });
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    var authorized = false;
    if (!check) {
      authorized = true;
      next({
        name: "login",
        query: { redirect: to.fullPath }
      });
    } else if (
      to.matched.some(
        record =>
          record.hasOwnProperty("meta") &&
          record.meta.hasOwnProperty("userType")
      )
    ) {
      if (
        to.matched.some(
          record =>
            record.meta &&
            typeof record.meta.userType == "number" &&
            record.meta.userType == user.user_type
        ) ||
        to.matched.some(
          record =>
            record.meta &&
            typeof record.meta.userType == "object" &&
            record.meta.userType.find(o => o == user.user_type)
        )
      ) {
        authorized = true;
      }
    } else {
      authorized = true;
    }
    if (!authorized) {
      next({
        name: "unauthorized",
        params: { oldPath: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
